module.exports = __webpack_public_path__ + "static/assets/7813339765b1ae72422cd1ea782be45d.svg";